export const assessmentTemplate = [
  {
    _id: "omniHealthHistory",
    omniAudit: {
      auditVersion: "1",
      omniRevision: "2",
      omniSchema: "assessmentTemplate",
      omniSchemaVersion: "1",
      writtenBy: null,
      createdBy: "melissaadmin9999",
      createdDate: "2023-07-21T00:00:00Z",
      modifiedBy: "rLundIII",
      modifiedDate: "2024-04-24T00:00:00Z",
      isActive: true,
    },
    omniData: {
      omniType: "omniHealthHistory",
      omniTypeVersion: 3,
      title: "Health Questionnaire",
      purpose: "Pre-screen specific info for memory related trials",
      description:
        "The information you provide will help us understand your personal health needs. We use this to match you to clinical trials.",
      duration: "Less than 5 minutes",
      directions:
        "Follow the onscreen instructions after you begin.</br></br>You can take this assessment again any time you experince a change in your health.",
      attribution: "",
      validated: "true",
      selfAssessment: false,
      startDate: null,
      completeDate: null,
      questions: [
        {
          omniID: "mq9",
          shortTitle: "subjectStroke",
          numberText: "1",
          text: "{has/have} {subject name/you} been hospitalized due to a stroke in the past 5 years?",
          subText: "",
          helpText: "Not just a change on an MRI or CT, but actually had a clinical stroke?",
          instructions: "",
          displayType: "button",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "yes",
              text: "Yes",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "no",
              text: "No",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "unsure",
              text: "I do not know",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "mq10",
          shortTitle: "subjectHeartAttack",
          numberText: "2",
          text: "{has/have} {subject name/you} been hospitalized due to a heart attack in the past 5 years?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "yes",
              text: "Yes",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "no",
              text: "No",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "unsure",
              text: "I do not know",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "mq10b",
          shortTitle: "subjectHeartProblems",
          numberText: "3",
          text: "{does/do} {subject name/you} have a physical health problems that limit {his/her/their/your} activities?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "yes",
              text: "Yes",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "no",
              text: "No",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "unsure",
              text: "I do not know",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "mq11",
          shortTitle: "subjectHeadTrauma",
          numberText: "4",
          text: "{has/have} {subject name/you} been hospitalized due to a head injury in the past 5 years?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "yes",
              text: "Yes",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "no",
              text: "No",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "unsure",
              text: "I do not know",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "mq12",
          shortTitle: "subjectSeizures",
          numberText: "5",
          text: "{has/have} {subject name/you} had more than one seizure in the past five years?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "yes",
              text: "Yes",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "no",
              text: "No",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "unsure",
              text: "I do not know",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "mq13",
          shortTitle: "subjectPsychiatricConcerns",
          numberText: "6",
          text: "{has/have} {subject name/you} experienced any serious depression or anxiety symptoms recently?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "yes",
              text: "Yes",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "no",
              text: "No",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "unsure",
              text: "I do not know",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "mq14",
          shortTitle: "subjectCancerHistory",
          numberText: "7",
          text: "{does/do} {subject name/you} have a history of cancer within 5 years?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "yes",
              text: "Yes",
              subText: "",
              helpText: "",
              nextQuestionID: "mq14a",
              isLast: false,
            },
            {
              value: "no",
              text: "No",
              subText: "",
              helpText: "",
              nextQuestionID: "mq15",
              isLast: false,
            },
            {
              value: "unsure",
              text: "I do not know",
              subText: "",
              helpText: "",
              nextQuestionID: "mq15",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "mq14a",
          shortTitle: "subjectCancerType",
          numberText: "7a",
          text: "Which of the following {was/were} {he/she/they/you} diagnosed with:",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "true",
          answerOptions: [
            {
              value: "basalsquamous",
              text: "Basal or squamous cell skin cancer",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: false,
            },
            {
              value: "cervicaldysplasia",
              text: "Cervical dysplasia",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: false,
            },
            {
              value: "prostatecancer",
              text: "Prostate cancer",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: false,
            },
            {
              value: "nonmetastaticbreastcancer",
              text: "Non-metastatic breast cancer",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: false,
            },
            {
              value: "other",
              text: "Other",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "mq15",
          shortTitle: "subjectAlcoholAbuse",
          numberText: "8",
          text: "{does/do} {subject name/you} routinely have more than two alcoholic drinks a day?",
          subText: "",
          helpText:
            "Or current excessive drinking to the point of cognitive impairment on a regular basis",
          instructions: "",
          displayType: "button",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "yes",
              text: "Yes",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "no",
              text: "No",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "unsure",
              text: "I do not know",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "mq17",
          shortTitle: "subjectMRI",
          numberText: "9",
          text: "{has/have} {subject name/you} had an MRI or CT scan of {his/her/their/your} head in the past 5 years?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "yes",
              text: "Yes",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "no",
              text: "No",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "unsure",
              text: "I do not know",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "mq25",
          shortTitle: "subjectNeurologistReason",
          numberText: "10",
          text: "{has/have} {subject name/you} been diagnosed with any of the following?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "true",
          answerOptions: [
            {
              value: "alz",
              text: "Alzheimer's disease (ALZ)",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: false,
            },
            {
              value: "ep",
              text: "Epilepsy",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: false,
            },
            {
              value: "mig",
              text: "Migraines",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: false,
            },
            {
              value: "ms",
              text: "Multiple Sclerosis (MS)",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: false,
            },
            {
              value: "pd",
              text: "Parkinson's disease",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: false,
            },
            {
              value: "none",
              text: "None",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: true,
            },
            {
              value: "unsure",
              text: "I do not know",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: true,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "mq19",
          shortTitle: "subjectWorseningCognition",
          numberText: "11",
          text: "Has {subject name's/your} memory or thinking been slowly getting worse over the past few years to the point where {he/she/they/you} can't do things {he/she/they/you} used to?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "yes",
              text: "Yes",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "no",
              text: "No",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "unsure",
              text: "I do not know",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "mq22",
          shortTitle: "subjectAssistanceNeed",
          numberText: "12",
          text: "How much assistance {does/do} {subject name/you} require due to memory or thinking issues?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "independent",
              text: "Absolutely Independent",
              subText: "No impact at all on daily activities - no change from 10 years ago",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "assistance",
              text: "Occasional Assistance",
              subText: "Requires occasional assistance with daily activities",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "dependent",
              text: "No Longer Independent",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "mq27",
          shortTitle: "subjectPreviousTrialParticipation",
          numberText: "13",
          text: "{has/have} {subject name/you} ever participated in a medical trial before?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "yes",
              text: "Yes",
              subText: "",
              helpText: "",
              nextQuestionID: "mq27a",
              isLast: false,
            },
            {
              value: "no",
              text: "No",
              subText: "",
              helpText: "",
              nextQuestionID: "mq5",
              isLast: false,
            },
            {
              value: "unsure",
              text: "I do not know",
              subText: "",
              helpText: "",
              nextQuestionID: "mq5",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "mq27a",
          shortTitle: "subjectPreviousTrialDate",
          numberText: "13a",
          text: "When {was/were} {subject name/you} finished with that trial?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "ongoing",
              text: "Ongoing",
              subText: "Trial has not yet completed",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "recent",
              text: "Finished Recently",
              subText: "Within last 6 months",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "midrange",
              text: "Within the Last Year",
              subText: "More than 6 months, but less than 12",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "longterm",
              text: "More than a year ago",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "unsure",
              text: "I do not know",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "mq5",
          shortTitle: "subjectWeight",
          numberText: "14",
          text: "What is {subject name's/your} weight (in pounds)?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "weight",
          answerOptions: [
            {
              value: "",
              text: "Weight",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "mq6",
          shortTitle: "subjectHeight",
          numberText: "15",
          text: "What is {subject name's/your} height (in feet and inches)?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "height",
          answerOptions: [
            {
              value: "",
              text: "Height",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "mq1",
          shortTitle: "subjectDateOfBirth",
          numberText: "16",
          text: "What is {subject name's/your} date of birth?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "date",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "",
              text: "Date of Birth",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "mq31",
          shortTitle: "subjectGiveEmergencyContact",
          numberText: "17",
          text: "Would you like to give us information about {his/her/their/your} emergency contact?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "yes",
              text: "Yes",
              subText: "",
              helpText: "",
              nextQuestionID: "mq23",
              isLast: false,
            },
            {
              value: "no",
              text: "No",
              subText: "",
              helpText: "",
              nextQuestionID: "mq4",
              isLast: false,
            },
            {
              value: "unsure",
              text: "I do not know",
              subText: "",
              helpText: "",
              nextQuestionID: "mq4",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "mq23",
          shortTitle: "subjectCareGiver",
          numberText: "18",
          text: "Who is {his/her/their/your} emergency contact?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "caregiver",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "",
              text: "",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "mq4",
          shortTitle: "subjectRace",
          numberText: "19",
          text: "Which of the following options best describes {his/her/their/your} race?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "americanindianalaskanative",
              text: "American Indian/Alaska Native",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "asian",
              text: "Asian",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "blackafricanamerican",
              text: "Black or African American",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "nativehawaiianotherpacificislander",
              text: "Native Hawaiian or other Pacific Islander",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "white",
              text: "White",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "biracialmultiracial",
              text: "Biracial or Multiracial",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "prefernottosay",
              text: "Prefer not to say",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "unsure",
              text: "I do not know",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "mq3",
          shortTitle: "subjectEthnicity",
          numberText: "20",
          text: "{is/are} {subject name/you} of Hispanic, Latino, or of Spanish origin?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "mexicanchicano",
              text: "Mexican, Mexican Am., or Chicano",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "puertorican",
              text: "Puerto Rican",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "cuban",
              text: "Cuban",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "other",
              text: "Other",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "false",
              text: "Non-Hispanic",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "prefernottosay",
              text: "Prefer not to say",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "unsure",
              text: "I do not know",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "mq2",
          shortTitle: "subjectZipCode",
          numberText: "21",
          text: "Please share {his/her/their/your} zip code so we can find trials close to {subject name/you}.",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "zipCode",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "",
              text: "Zip Code",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
      ],
      assessmentResults: { finalResult: null },
    },
  },
];
export const assessmentScoring = [
  {
    typeID: "omniHealthHistoryQuestionaire",
    algorithms: [
      {
        name: "sum",
        minScore: 0,
        maxScore: 5,
        formula: null,
        questions: [],
      },
    ],
  },
];
